import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {EformAPI} from '../e-form.api';
import {RestDataSource} from '../../shared/rest-data-source';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Toast} from '../../shared/toast/toast';
import {MatLegacySlideToggleChange as MatSlideToggleChange} from '@angular/material/legacy-slide-toggle';
import {TranslateService} from '@ngx-translate/core';
import {FormGenerateComponent} from '../form-generate/form-generate.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {DeleteFormComponent} from '../dialog/delete-form/delete-form.component';
import {PaginatorComponent} from '../../shared/paginator';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import { IdexService } from 'app/idex.service';
import { isValidArrayIndex } from '../../shared/helper-functions';

@Component({
   selector: 'app-form-list',
   templateUrl: './form-list.component.html',
   styleUrls: ['./form-list.component.scss']
})

export class FormListComponent implements OnInit {
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild('wrapper') container: ElementRef;
   @ViewChild(AppLoaderComponent, {static: true}) loader: AppLoaderComponent;
   @ViewChild('search', {static: true}) search: ElementRef;

   private timer: any;
   dataSource = new RestDataSource<any>();
   formType: string;
   selectedRowIndex: number;
   displayedColumns = ['select', 'formName', 'status', 'createdBy', 'updateDate', 'createdDate', 'versions', 'isActive', 'menu'];
   filterValue = '';
   buttonNew: string;
   orderBy = '';
   orderType = '';
   sortOrder = 'updateDate';
   sortDirect = 'desc';
   searchFocused: boolean;
   index: any;
   size: any;
   searchResult: any[];
   preventBlur: boolean;
   searchvalue: any;
   searching: any;
   draft: any;
   publish: any;
   allData: any[] = [];
   isLoadingResults = false;
   formList = [];
   isSelectAll = false;
   disabledBtn = true;
   data: any;
   hideDeleteButton: boolean = true;

   constructor(private api: EformAPI, private route: ActivatedRoute, private dialog: MatDialog,
               private toast: Toast, private translate: TranslateService, private router: Router,private service: IdexService) {
   }

   ngOnInit(): void {
      this.route.params.forEach((params: Params) => {
         localStorage.setItem('form-type', params['formtype']);
         if (params['formtype'] === 'form') {
            this.formType = 'FM';
            this.translate.get('eform.button.new-form').subscribe(s => {
               this.buttonNew = s;
            });

         } else {
            this.formType = 'TP';
            this.translate.get('eform.button.new-template').subscribe(s => {
               this.buttonNew = s;
            });
         }
         this.translate.get('eform.status.publish').subscribe(s => {
            this.publish = s;
         });
         this.translate.get('eform.status.draft').subscribe(s => {
            this.draft = s;
         });
         this.clearData();
         if (params['status'] === 'open') {
            window.localStorage.removeItem('searchValue');
         }
         if (params['status'] === 'back') {
            this.searching = localStorage.getItem('searchValue');
            this.paginator.page = Number(localStorage.getItem('page_index'));
            this.filterValue = (this.searching === null) ? '' : this.searching;
         }
         this.getBusinessSiteBySiteCode();
      });

   }
   getBusinessSiteBySiteCode() {
      this.service.getBusinessSiteBySiteCode(localStorage.getItem('tin')).subscribe(rs => {
         if (rs) {
            localStorage.setItem('siteCode', rs.siteCode);
            this.getListForm('');
         }
      }, e => {
         this.handleErrors(e);
      });
   }

   onClickEForm(formId: number) {
      this.selectedRowIndex = formId;
      this.router.navigate(['/eform/create/' + formId]);
   }

   getListForm(type) {
      this.loader.show();
      this.selectedRowIndex = -1;
      this.isLoadingResults = true;
      this.dataSource = new RestDataSource<any>();
      this.dataSource.paginator = this.paginator;
      this.index = this.paginator.page;
      this.size = this.paginator.size;
      localStorage.setItem('page_index', this.index);
      if (this.size === undefined) {
         this.size = 50;
      }
      if (this.sort) {
         this.dataSource.sort = this.sort;
      }

      this.sortOrder = localStorage.getItem('sortOrder') || 'updateDate';
      this.sortDirect = localStorage.getItem('sortDirect') || 'desc';
      if (type === 'sort' && this.sort) {
         this.sortOrder = this.sort.active;
         this.sortDirect = this.sort.direction;
         localStorage.setItem('sortOrder', this.sortOrder);
         localStorage.setItem('sortDirect', this.sortDirect);
      }
      this.api.listEForm(this.formType, localStorage.getItem('siteCode'), this.filterValue, this.sortOrder,
         this.sortDirect, this.index, this.size, null)
         .subscribe(data => {
            this.data = data;
            for (const list of data.content) {
               list.createdDate = new Date(list.createdDate.replace(/-/g, '/')); // new Date(list.createdDate);
               list.updateDate = new Date(list.updateDate.replace(/-/g, '/'));
            }

            this.dataSource.loaded(data);
            this.allData = data.content;
            this.isLoadingResults = false;
            if (this.allData.length === 0) {
               this.isLoadingResults = true;
            }
            this.container.nativeElement.scrollTop = 0;
            this.loader.hide();
         }, e => {
            this.handleErrors(e);
            this.loader.hide();
         });
   }

   // Wait for Specification Error Message
   handleErrors(e: any) {
      if (e.status === 404) {
         this.toast.error('Service Not Found.');
      }
   }

   activeFormList(formName: string, id: any, event: MatSlideToggleChange) {
      this.api.activeFormList(id, event.checked)
         .subscribe((response) => {
            let index = this.dataSource.data.findIndex((x) => x.formId === id);
            if (event.checked) {
               this.translate.get('eform.activated',{formName: formName}).subscribe(s => {
                  this.toast.success(s);
                  this.hideDeleteButton = true;
                  if (isValidArrayIndex(index, this.dataSource.data)) {
                     this.dataSource.data[index].isActive = event.checked;
                     this.selectCheckbox(event, id);
                  }
               });
            } else {
               this.translate.get('eform.inactivated',{formName: formName}).subscribe(s => {
                  this.toast.warn(s);
                  this.hideDeleteButton = false;
                  if (isValidArrayIndex(index, this.dataSource.data)) {
                     this.dataSource.data[index].isActive = event.checked;
                     this.selectCheckbox(event, id);
                  }
               });
            }
         }, e => {
            this.handleErrors(e);
         });
   }

   clearData() {
      this.paginator.firstPage();
      this.filterValue = '';
      this.search.nativeElement.value = '';
      this.disabledBtn = true;
      this.formList = [];
      this.isSelectAll = false;
   }

   onSearch(value: any) {
      this.searchFocused = false;
      this.searchvalue = value;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = encodeURIComponent(value.trim());
      if (q.length === 0) {
         value = '';
      } else {
         value = value.trim(); // Remove whitespace
         value = value.toLowerCase();
      }
      this.filterValue = q;
      this.getListForm('');
   }

   onSearchChange(input: any, e: any) {
      localStorage.setItem('searchValue', input.value);
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      this.filterValue = encodeURIComponent(input.value.trim());
      if (this.filterValue.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.api.listEForm(this.formType, localStorage.getItem('siteCode'), this.filterValue, this.orderBy,
            this.orderType, 0, 8, null)
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data.content;
                  }
               });
      }, 300);
   }

   openPreview(formId: any) {
      const dialogRef = this.dialog.open(FormGenerateComponent, {
         disableClose: true,
         data: {
            formId: formId
         },
         panelClass: 'my-dialog',
         width: '1350px',
         height: 'auto'
      });
      dialogRef.componentInstance.isPreview = true;

      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.translate.get('eform.submit.success').subscribe(s => {
               this.toast.success(s);
            });
         }
      });
   }

   onClickDel(formId: any) {
      const dialogRef = this.dialog.open(DeleteFormComponent, {
         disableClose: true,
         height: '110px',
         data: {
            formId: formId,
            formList: this.dataSource.selected
         },
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result.response) {
            if (result.msg.code === 200) {
               this.toast.success(result.msg.message);
               this.clearData();
               this.getListForm('');
            } else {
               this.toast.error(result.msg.message);
            }
         }
      });
   }

   selectCheckbox(event, formId) {
      if (formId === -1) {
         this.isSelectAll = event.checked;
      }
      const checkFormList = this.checkFormList(this.dataSource.selected);
      if (this.isSelectAll) {
         this.isSelectAll = checkFormList ? true : false;
      }
      this.disabledBtn = (!checkFormList && !this.isSelectAll) ? true : false;
   }

   checkFormList(formList) {
      if (formList.length === 0) {
         return false;
      }

      const isPub = formList.some((form) => (form.publishDate && form.isActive) ? true : false);
      if (isPub) {
         return false;
      }
      for (const form of formList) {
         if ((form.publishDate && !form.isActive) || !form.publishDate) {
            return true;
         }
      }
   }

   checkButtonDel(row: any): string {
      return row.publishDate ? 'publish' : 'draft';
   }

   handleMenuButtonClick(row: any, event: MouseEvent) {
      event.stopPropagation();
      if ((row.publishDate === 'draft') || (!this.hideDeleteButton)) {
          event.stopPropagation();
      } else {
          event.preventDefault();
      }
  }

}

